import { OutlookOrganizerDto, OutlookRecipientDto } from "../dto";

export const TokenIOutlookOrganizerRepository = "IOutlookOrganizerRepository";

export interface IOutlookOrganizerRepository {
    GetOrganizer(): OutlookOrganizerDto | undefined;
    GetRealOrganizerOfAppointment(): Promise<OutlookRecipientDto | undefined>;
}